import React from 'react';
import Nav from '../Nav/Nav.jsx';
import About from '../About/About.jsx';
import Contact from '../Contact/Contact.jsx';
import Header from '../Header/Header.jsx';
import Projects from '../ProjectsContainer/ProjectsContainer.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './Home.module.css';
import NavMobile from '../NavMobile/NavMobile.jsx';

const Home = () => {
     return (
          <div className={styles.container}>
               <Header />
               <Nav />
               <NavMobile />
               <About />
               <Projects />
               <Contact />
               <Footer />
          </div>
     );
};

export default Home;
